import React, { useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Navigation, Footer } from '../components/landing';
import { localeFromPath } from '../i18n/path-locale';

const TITLE_EN = "We're here to help — AidFone";
const TITLE_FR = 'Nous sommes là pour vous aider — AidFone';

const EMAIL = 'support@aidfone.com';

export const Contact: React.FC = () => {
  const location = useLocation();
  const { t } = useTranslation();
  const locale = localeFromPath(location.pathname);

  useEffect(() => {
    document.title = locale === 'fr' ? TITLE_FR : TITLE_EN;
    document.documentElement.lang = locale === 'fr' ? 'fr-CA' : 'en';
  }, [locale]);

  return (
    <div className="min-h-screen bg-brand-bg font-body">
      <Navigation />

      <main className="pt-24">
        <section className="py-16">
          <div className="max-w-[800px] mx-auto px-6 text-center">
            <h1 className="font-display text-[clamp(2rem,5vw,3rem)] font-semibold mb-6 leading-tight text-brand-text">
              {t('pages.contact.title')}
            </h1>
            <p className="text-brand-text-light text-lg mb-12 max-w-[600px] mx-auto">
              {t('pages.contact.intro')}
            </p>
          </div>
        </section>

        <section className="pb-16">
          <div className="max-w-[800px] mx-auto px-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="bg-white border border-brand-border rounded-xl p-8 text-center">
                <div className="mx-auto mb-4 w-12 h-12 rounded-full bg-brand-primary/10 flex items-center justify-center">
                  <span className="material-symbols-outlined text-brand-primary text-3xl" aria-hidden="true">mail</span>
                </div>
                <h2 className="font-display text-xl font-semibold mb-2 text-brand-text">
                  {t('pages.contact.emailLabel')}
                </h2>
                <p className="text-brand-text-light mb-4 text-sm">
                  {t('pages.contact.emailBody')}
                </p>
                <a
                  href={`mailto:${EMAIL}`}
                  className="inline-block text-brand-primary font-semibold no-underline border-b border-brand-primary hover:text-brand-accent hover:border-brand-accent transition-colors"
                >
                  {EMAIL}
                </a>
              </div>

              <div className="bg-white border border-brand-border rounded-xl p-8 text-center">
                <div className="mx-auto mb-4 w-12 h-12 rounded-full bg-brand-primary/10 flex items-center justify-center">
                  <span className="material-symbols-outlined text-brand-primary text-3xl" aria-hidden="true">location_on</span>
                </div>
                <h2 className="font-display text-xl font-semibold mb-2 text-brand-text">
                  {t('pages.contact.officeLabel')}
                </h2>
                <p className="text-brand-text-light text-sm leading-relaxed">
                  {t('pages.contact.officeBody')}
                </p>
              </div>
            </div>

            <div className="mt-10 bg-brand-bg-warm border border-brand-border rounded-xl p-8 text-center">
              <h2 className="font-display text-xl font-semibold mb-3 text-brand-text">
                {t('pages.contact.responseLabel')}
              </h2>
              <p className="text-brand-text-light leading-relaxed max-w-[600px] mx-auto">
                {t('pages.contact.responseBody')}
              </p>
            </div>
          </div>
        </section>

        <section className="py-16 bg-brand-bg-warm">
          <div className="max-w-[700px] mx-auto px-6 text-center">
            <h2 className="font-display text-[clamp(1.4rem,4vw,2rem)] font-semibold mb-4 text-brand-text">
              {t('pages.contact.tryTitle')}
            </h2>
            <p className="text-brand-text-light mb-8 text-lg">
              {t('pages.contact.tryBody')}
            </p>
            <Link
              to="/configure"
              className="inline-flex items-center justify-center px-7 py-3.5 font-body text-base font-semibold no-underline rounded-md bg-brand-accent text-white shadow-[0_4px_14px_rgba(224,123,76,0.35)] hover:bg-[#c96a3f] transition-all"
            >
              {t('pages.contact.tryCta')}
            </Link>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default Contact;
